import React from 'react'
import classNames from 'classnames'

import { SidebarContainer } from '@app/component/sidebars'
import { ModalContainer } from '@app/component/modals'
import { Navigation } from '@core/nav'
import { Loader } from '@ui'
import { useRootSelector } from '@app/store'

import connect from './connect'
import './index.scss'
import { useIsManagerAssistantVisible } from '@app/component/core/manager-assistant/use-is-manager-assistant-visible'

const App = ({
  full,
  noPadding,
  noScroll,
  auth,
  hideNav,
  children,
  noAnimation
}) => {
  // The manager assistant column is fixed to the right edge and mounted above the router's
  // <Switch> (app/routing/Routes.js), so the shell has to reserve a gutter for it — same
  // hook the column is rendered on, so the two can't disagree. ModalProvider used to wrap
  // this subtree; it now lives in Routes, above both the shell and the column.
  const isManagerAssistantVisible = useIsManagerAssistantVisible()
  const isManagerAssistantExpanded = useRootSelector(
    (state) => state.managerAssistant.expanded
  )

  const onScroll = (e) => {
    if (noScroll) return
    e.preventDefault()
  }

  return (
    <div
      className={classNames(
        'ds-app',
        {
          'is-full': full,
          'no-padding': noPadding,
          'has-manager-assistant': isManagerAssistantVisible,
          'has-manager-assistant-expanded': isManagerAssistantVisible && isManagerAssistantExpanded
        }
      )}
      onScroll={onScroll}
    >
      <ModalContainer />
      <SidebarContainer />
      {auth && !hideNav && <Navigation />}
      <div className={'ds-app-scroll' + (noScroll ? ' is-no-scroll' : '')}>
        <div>
          <React.Suspense fallback={<Loader size={Loader.SIZES.LARGE} type={Loader.TYPES.OVERLAY} />}>
            <div className='ds-app-content'>
              {children}
            </div>
          </React.Suspense>
        </div>
      </div>
    </div>
  )
}

export default connect(App)
